import {useSelector} from 'react-redux';
import Selector from '../../selectors/modals_info';

import VIP20 from './vip20';
import WeeklyRakeback from './weekly-rakeback';
import MonthlyRakeback from './monthly-rakeback';
import RegularFreeplay from './regular-freeplay';
import DepositAssistToken from './deposit-assist-token';
import RandomBoost from './random-boost';
import BirthdayBonus from './birthday-bonus';

export default () => {
    const {modal} = useSelector(Selector);

    if(modal === 'vip20') return <VIP20 />;
    if(modal === 'weekly-rakeback') return <WeeklyRakeback />;
    if(modal === 'monthly-rakeback') return <MonthlyRakeback />;
    if(modal === 'regular-freeplay') return <RegularFreeplay />;
    if(modal === 'deposit-assist-token') return <DepositAssistToken />;
    if(modal === 'random-boost') return <RandomBoost />;
    if(modal === 'birthday-bonus') return <BirthdayBonus />;
    return <></>;
}